export const TRANSLATIONS_KR = {
  academie: "academia",
  usage: "usegia",
  marche: "servicia",
};
